/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TaskRelationType } from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { AutocompleteItem, ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { GanttTaskRelation } from '../resources/gantt.model';

export type GanttPredecessorKitDialogConfig = {
  taskId: ID;
  name: string;
  predecessors: GanttTaskRelation[];

  validateRelations(taskId: ID, relations: GanttTaskRelation[]): GanttTaskRelation[];
  findTasks(scheduleId: ID, taskNumber: string, excluding: ID): AutocompleteItem[];
};

@Injectable()
export class GanttChartBusinessService implements InitDialogViewService<GanttPredecessorKitDialogConfig> {
  constructor(private dictionaries: DictionaryService) {
  }

  initDialogView(route: DialogRouteSnapshot<GanttPredecessorKitDialogConfig>): any {
    return {
      relationshipTypeDict: this.dictionaries.getByEnum(TaskRelationType),
    };
  }

}
